// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1iSJN","productName":"Table_productName__2DxRe"};